(function () {

    angular
        .module('smartertoolsApp')
        .factory('payments', ['$http', 'refreshToken', 'cacheControl', paymentsFactory]);

    function paymentsFactory($http, refreshToken, cacheControl) {
        var urlBase = apiRootUrl;
        var paymentMethodsPromise;
        var paymentMethodsWithExpiredPromise;

        return {
            getPaymentMethods: getPaymentMethods,
            clearPaymentMethodsCache: clearPaymentMethodsCache,
            getPaymentMethodsWithExpired: getPaymentMethodsWithExpired,
            invoiceLaterText:
                'By clicking on the "Pay Now" box, you agree to remit payment ' +
                'for any products or services purchased with SmarterTools ' +
                'within 30 days. '
        };

        // -----------------------------------------------

        function getPaymentMethods() {
            if (paymentMethodsPromise)
                return paymentMethodsPromise;

            paymentMethodsPromise = refreshToken.refreshToken()
                .then(() => $http.post(`${urlBase}v1/cart/payment-methods`, JSON.stringify({}), { cache: cacheControl.getCache('paymentMethodsCache') }))
                .then(function (response) {
                    var retVal = response.data.Methods;
                    for (let i = 0; i < retVal.length; i++) {
                        retVal[i].SecurityCode = retVal[i].SecurityCode || '';
                        retVal[i].CardNumber = retVal[i].CardNumber || '';
                        retVal[i].NameOnCard = retVal[i].NameOnCard || '';
                        retVal[i].SaveCard = retVal[i].SaveCard || false;
                        retVal[i].UniqueId = retVal[i].PaymentType + ':' + retVal[i].PaymentMethodId;
                        if (retVal[i].ExpirationDate)
                            retVal[i].ExpirationDate = new Date(retVal[i].ExpirationDate);
                    }
                    paymentMethodsPromise = null;
                    return retVal;
                });
            return paymentMethodsPromise;
        }

        function clearPaymentMethodsCache() {
            cacheControl.getCache('paymentMethodsCache').remove(urlBase.urlBase + 'v1/cart/payment-methods');
        }

        function getPaymentMethodsWithExpired() {
            if (paymentMethodsWithExpiredPromise)
                return paymentMethodsWithExpiredPromise;
            paymentMethodsWithExpiredPromise = refreshToken.refreshToken()
                .then(() => $http.post(urlBase + 'v1/cart/payment-methods', JSON.stringify({ IncludeExpired: true }), { cache: cacheControl.getCache('paymentMethodsCache') }))
                .then((response) => {
                    var retVal = response.data.Methods;
                    for (let i = 0; i < retVal.length; i++) {
                        retVal[i].SecurityCode = retVal[i].SecurityCode || '';
                        retVal[i].CardNumber = retVal[i].CardNumber || '';
                        retVal[i].NameOnCard = retVal[i].NameOnCard || '';
                        retVal[i].SaveCard = retVal[i].SaveCard || false;
                        retVal[i].UniqueId = retVal[i].PaymentType + ':' + retVal[i].id;
                        if (retVal[i].ExpirationDate)
                            retVal[i].ExpirationDate = new Date(retVal[i].ExpirationDate);
                    }
                    paymentMethodsWithExpiredPromise = null;
                    return retVal;
                });
            return paymentMethodsWithExpiredPromise;
        }
    }

})();